// 코드 예제 및 전체 API 문서는 http://wix.to/94BuAAs에서 확인하세요.

$w.onReady(function () {
	//TODO: write your page related code here...

});